module.exports = __webpack_public_path__ + "static/media/201IT222.9f9da890.jpeg";